import type { Customer } from "../models/Customer";

export const generateCustomerName = (customer: Customer) =>
  `${customer?.name} (${customer.id})`;
